import Vue from 'vue'
import VueStorage from 'vue-ls'
import config from '@/config/default.config'
import { VueAxios } from '@/utils/request'
import store from '@/store'

// base library
import Antdv from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
// ext library
import Modal from '@/components/Modal'
import IconFont from '@/components/IconFont'
import './filters/menuLocalName'

Vue.use(Antdv)
Vue.use(VueStorage, config.storageOptions)
Vue.use(VueAxios)
Vue.use(IconFont)

Vue.prototype.$dialog = {
  iframe: Modal.iframe
}

function demoAddMethod (el, binding, vNode) {
  const vm = vNode.context // 绑定this
  const { $store, $message } = vm
  const { value, arg } = binding
  el.onclick = function (e) {
    if ($store.getters.isDemo) {
      $message.warning(vm.$t('layouts.demo.tips'))
    } else {
      vm[value].apply(vm, arg && (arg instanceof Array ? arg : [arg]))
    }
    e.preventDefault()
    e.stopPropagation()
  }
}

Vue.directive('demo', {
  bind: demoAddMethod,
  componentUpdated: demoAddMethod
})

Vue.filter('menuNameRender', function (pane) {
  let lang = store.getters.currentLang
  let menuName = pane?.menuName?.[lang] || pane.tab
  if (typeof pane.menuName === 'string') {
    const langCodes = {
      'zh_CN': 'menuName',
      'en_US': 'menuEnName',
      'ko_KR': 'menuKrName'
    }
    menuName = pane[langCodes[lang]]
  }
  return menuName
})

// 首字母大写
const ucstr = (text, space = true) => text.toLocaleLowerCase().replace(new RegExp('(' + (space ? ' |^' : '^') + ')[a-z]', 'g'), (L) => L.toUpperCase())
Vue.directive('ucstr', {
  inserted (el, binding) {
    el.innerText = ucstr(binding.value)
  }
})
Vue.filter('ucstr', (...value) => ucstr.apply(this, value))
Vue.prototype.$ucstr = ucstr

// 单位
Vue.prototype.$ucUnit = function (path, count) {
  if (path && /^measure_/.test(path)) {
    return this.$tc(path, count, { count })
  }
  return `${(count || '')}${(path || '')}`
}
